import axios from 'http.service';
import apiErrorMsg from 'Common/Utils/apiErrorMsg';

const baseUrl = '/api/v2/emails';

export const getAllTemplatesByGroup = async (contractgroupId, errorCb) => {
	const {
		status,
		data: { data, errors }
    } = await axios.get(baseUrl + '/all/' + contractgroupId);
	if (status === 200) {
		return data;
    }
	const errorMessage = apiErrorMsg(status, errors);
	return errorCb(errorMessage);
};
export async function saveTemplate(dto, errorCb) {
	const { status } = await axios.put(baseUrl, { emailTemplate: dto });
	if (status === 200) return true;
	const errorMessage = apiErrorMsg(status);
	return errorCb(errorMessage);
}
